module.exports = __webpack_public_path__ + "static/media/bolero_icon_b.13e3dd9e.png";